import { Stack, StackProps } from '@mui/material'
import { LoadingSkeleton } from 'ComponentLibrary/src/atoms/LoadingSkeleton/index'

type LoadingSkeletonContainerProps = {
    loadersPattern: { count: number; height: string }[]
} & StackProps

export default function LoadingSkeletonContainer({
    loadersPattern,
    gap,
    justifyContent,
    padding,
    ...stackProps
}: LoadingSkeletonContainerProps) {
    return (
        <Stack
            alignItems="center"
            width="100%"
            height="100%"
            boxSizing="border-box"
            justifyContent={justifyContent}
            padding={padding}
            gap={gap}
            {...stackProps}
        >
            {loadersPattern.map(({ count, height }, index) => (
                <LoadingSkeleton key={index} width="90%" count={count} height={height} sx={{ transform: 'unset' }} />
            ))}
        </Stack>
    )
}
